import request from '../utils/http'

// 906 街道单位管理-列表
export function getStreetList(data) {
  return request({
    url: '/service/xld/bell_street_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_streetpage',
      ...data
    },
  })
}

// 907 街道单位管理-添加
export function addStreet(data) {
  return request({
    url: '/service/xld/bell_street_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_streetadd',
      ...data
    },
  })
}

// 908 街道单位管理-修改
export function editStreet(data) {
  return request({
    url: '/service/xld/bell_street_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_streetedit',
      ...data
    },
  })
}

// 909 街道单位管理-查看
export function getStreetDetail(id) {
  return request({
    url: '/service/xld/bell_street_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_streetview',
      id
    },
  })
}

// 910 居委单位管理-列表
export function getCommunityList(data) {
  return request({
    url: '/service/xld/bell_neighborhood_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_neighborhoodpage',
     ...data
    },
  })
}

// 911 居委单位管理-添加
export function addCommunity(data) {
  return request({
    url:'/service/xld/bell_neighborhood_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_neighborhoodadd',
    ...data
    },
  })
}

// 912 居委单位管理-修改
export function editCommunity(data) {
  return request({
    url: '/service/xld/bell_neighborhood_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_neighborhoodedit',
   ...data
    },
  })
}

// 913 居委单位管理-查看
export function getCommunityDetail(id) {
  return request({
    url: '/service/xld/bell_neighborhood_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_neighborhoodview',
      id
    },
  })
}

// 914 居民社区管理-列表
export function getResidentList(data) {
  return request({
    url: '/service/xld/bell_community_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_communitypage',
      ...data
    },
  })
}

// 915 居民社区管理-添加
export function addResident(data) {
  return request({
    url: '/service/xld/bell_community_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_communityadd',
     ...data
    },
  })
}

// 916 居民社区管理-修改
export function editResident(data) {
  return request({
    url: '/service/xld/bell_community_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_communityedit',
    ...data
    },
  })
}

// 917 居民社区管理-查看
export function getResidentDetail(id) {
  return request({
    url: '/service/xld/bell_community_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_communityview',
      id
    },
  })
}

// 918 服务机构管理-列表
export function getServiceList(data) {
  return request({
    url: '/service/xld/bell_service_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_servicepage',
     ...data
    },
  })
}

// 919 服务机构管理-添加
export function addService(data) {
  return request({
    url: '/service/xld/bell_service_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_serviceadd',
    ...data
    },
  })
}

// 920 服务机构管理-修改
export function editService(data) {
  return request({
    url: '/service/xld/bell_service_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_serviceedit',
   ...data
    },
  })
}

// 921 服务机构管理-查看
export function getServiceDetail(id) {
  return request({
    url: '/service/xld/bell_service_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_serviceview',
      id
    },
  })
}

// 922 服务责任片区管理-列表
export function getServiceAreaList(data) {
  return request({
    url: '/service/xld/bell_resarea_Hand.ashx', // 这里的接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_resareapage',
      ...data
    },
  })
}

// 923 服务责任片区管理-添加
export function addServiceArea(data) {
  return request({
    url: '/service/xld/bell_resarea_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_resareaadd',
   ...data
    },
  })
}


// 924 服务责任片区管理-修改
export function editServiceArea(data) {
  return request({
    url: '/service/xld/bell_resarea_Hand.ashx',
    method: "get",  //接口方法
    params: {
      Method: 'bell_resareaedit',
   ...data
    },
  })
}

// 925 服务责任片区管理-查看
export function getServiceAreaDetail(id) {
  return request({
    url: '/service/xld/bell_resarea_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 查看详情一般使用 get 方法
    params: {
      Method: 'bell_resareaview',
      id
    },
  })
}

// 942 社区陪护服务订单-列表
export function getCommunityServiceOrderList(data) {
  return request({
    url: '/service/xld/park_catering_service_order_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_orderpage',
      ...data
    },
  })
}

// 944 社区陪护服务订单-修改
export function editCommunityServiceOrder(data) {
  return request({
    url: '/service/xld/park_catering_service_order_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_orderedit',
      ...data
    },
  })
}

// 945 社区陪护服务订单-查看
export function getCommunityServiceOrderDetail(id) {
  return request({
    url: '/service/xld/park_catering_service_order_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 查看详情一般使用 get 方法
    params: {
      Method: 'park_catering_service_orderview',
      id
    },
  })
}

// 975 职能分配管理-列表
export function getFunctionList(data) {
  return request({
    url: '/service/xld/bell_area_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_areapage',
      ...data
    },
  })
}

// 975 职能分配管理-详情
export function getFunctionDetail(data) {
  return request({
    url: '/service/xld/bell_area_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_arealist',
      ...data
    },
  })
}

// 980 派单管理-添加
export function addDispatch(data) {
  return request({
    url: '/service/xld/park_catering_service_order_get_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_getadd',
      ...data
    },
  })
}

// 964 业务过程记录-添加
export function addBusinessRecord(data) {
  return request({
    url: '/service/xld/park_catering_service_order_detail_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_detailadd',
      ...data
    },
  })
}

// 965 业务过程记录-修改
export function editBusinessRecord(data) {
  return request({
    url: '/service/xld/park_catering_service_order_detail_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_detailedit',
      ...data
    },
  })
}

// 960 服务超时追加费用管理-添加
export function addTimeoutCharge(data) {
  return request({
    url: '/service/xld/park_catering_service_order_fee_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_feeadd',
      ...data
    },
  })
}



// 961 服务超时追加费用管理-修改
export function editTimeoutCharge(data) {
  return request({
    url: '/service/xld/park_catering_service_order_fee_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_feeedit',
      ...data
    },
  })
}

// 972 额外交通费用管理-添加
export function addExtraTransportationCharge(data) {
  return request({
    url: '/service/xld/park_catering_service_order_feetraffic_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_feetrafficadd',
      ...data
    },
  })
}

// 973 额外交通费用管理-修改
export function editExtraTransportationCharge(data) {
  return request({
    url: '/service/xld/park_catering_service_order_feetraffic_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_feetrafficedit',
      ...data
    },
  })
}

// 1012 其他额外费用管理-添加
export function addOtherExtraCharge(data) {
  return request({
    url: '/service/xld/park_catering_service_order_feeother_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_feeotheradd',
      ...data
    },
  })
}

// 1012 其他额外费用管理-修改
export function editOtherExtraCharge(data) {
  return request({
    url: '/service/xld/park_catering_service_order_feeother_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_feeotheredit',
      ...data
    },
  })
}
  

// 983 用户地址管理-列表
export function getUserAddressList(data) {
  return request({
    url: '/service/xld/report_archives_addr_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'report_archives_addrpage',
      ...data
    },
  })
}

// 984 用户地址管理-添加
export function addUserAddress(data) {
  return request({
    url: '/service/xld/report_archives_addr_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'report_archives_addradd',
      ...data
    },
  })
}

// 930 附加设备器具-列表
export function getEquipmentList(data) {
  return request({
    url: '/service/xld/bell_meachine_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_meachinepage',
      ...data
    },
  })
}

// 931 附加设备器具-添加
export function addEquipment(data) {
  return request({
    url: '/service/xld/bell_meachine_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_meachineadd',
      ...data
    },
  })
}

// 932 附加设备器具-修改
export function editEquipment(data) {
  return request({
    url: '/service/xld/bell_meachine_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_meachineedit',
      ...data
    },
  })
}

// 933 附加设备器具-查看
export function getEquipmentDetail(id) {
  return request({
    url: '/service/xld/bell_meachine_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_meachineview',
      id
    },
  })
}

// 988 代拿报告服务专用信息-列表
export function getReportServiceList(data) {
  return request({
    url: '/service/xld/park_catering_service_order_specibook_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_specibookpage',
      pageindex: 1,
      pagesize: 1,
      ...data
    },
  })
}

// 990 代拿报告服务专用信息-修改
export function editReportService(data) {
  return request({
    url: '/service/xld/park_catering_service_order_specibook_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_specibookedit',
      ...data
    },
  })
}

// 992 代配药/代买药服务专用信息-列表
export function getMedicineDispatchServiceList(data) {
  return request({
    url: '/service/xld/park_catering_service_order_specimedi_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_specimedipage',
      pageindex: 1,
      pagesize: 1,
      ...data
    },
  })
}

// 994 代配药/代买药服务专用信息-修改
export function editMedicineDispatchService(data) {
  return request({
    url: '/service/xld/park_catering_service_order_specimedi_Hand.ashx', // 接口地址根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_specimediedit',
      ...data
    },
  })
}

// 996 代问诊（咨询/预诊）服务专用信息-列表
export function getConsultationServiceList(data) {
  return request({
    url: '/service/xld/park_catering_service_order_speciask_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_speciaskpage',
      pageindex: 1,
      pagesize: 1,
      ...data
    },
  })
}

// 997 代问诊（咨询/预诊）服务专用信息-修改
export function edidConsultationService(data) {
  return request({
    url: '/service/xld/park_catering_service_order_speciask_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_speciaskedit',
      ...data
    },
  })
}


// 999 预约检查-列表
export function getAppointmentCheckList(data) {
  return request({
    url: '/service/xld/park_catering_service_order_speciread_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_specireadpage',
      pageindex: 1,
      pagesize: 1,
      ...data
    },
  })
}

// 1001 预约检查-修改
export function editAppointmentCheck(data) {
  return request({
    url: '/service/xld/park_catering_service_order_speciread_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_specireadedit',
      ...data
    },
  })
}

// 1003 代办住院出院手续服务补充信息-列表
export function getHospitalProceduresList(data) {
  return request({
    url: '/service/xld/park_catering_service_order_yuan_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_yuanpage',
      pageindex: 1,
      pagesize: 1,
      ...data
    },
  })
}

// 1005 代办住院出院手续服务补充信息-修改
export function editHospitalProcedures(data) {
  return request({
    url: '/service/xld/park_catering_service_order_yuan_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_yuanedit',
      ...data
    },
  })
}

// 1007 入院/出院接送-列表
export function getInHospitalOutHospitalList(data) {
  return request({
    url: '/service/xld/park_catering_service_order_jie_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_jiepage',
      pageindex: 1,
      pagesize: 1,
      ...data
    },
  })
}

// 1009 入院/出院接送-修改
export function editInHospitalOutHospital(data) {
  return request({
    url: '/service/xld/park_catering_service_order_jie_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_jieedit',
      ...data
    },
  })
}

// 1016 陪护合作机构管理-列表
export function getCooperationOrgList(data) {
  return request({
    url: '/service/xld/bell_institution_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_institutionpage',
      ...data
    },
  })
}

// 1017 陪护合作机构管理-添加
export function addCooperationOrg(data) {
  return request({
    url: '/service/xld/bell_institution_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_institutionadd',
      ...data
    },
  })
}

// 1018 陪护合作机构管理-修改
export function editCooperationOrg(data) {
  return request({
    url: '/service/xld/bell_institution_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_institutionedit',
      ...data
    },
  })
}

// 1019 陪护合作机构管理-查看
export function getCooperationOrgDetail(id) {
  return request({
    url: '/service/xld/bell_institution_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_institutionview',
      id
    },
  })
}

// 938 服务内容-列表
export function getServiceContentList(data) {
  return request({
    url: '/service/xld/bell_servicecont_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_servicecontpage',
      ...data
    },
  })
}

// 1017 陪护合作机构管理-添加
export function addServiceContent(data) {
  return request({
    url: '/service/xld/bell_servicecont_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_institutionadd',
      ...data
    },
  })
}

// 940 服务内容-修改
export function editServiceContent(data) {
  return request({
    url: '/service/xld/bell_servicecont_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_servicecontedit',
      ...data
    },
  })
}

// 941 服务内容-查看
export function getServiceContentDetail(id) {
  return request({
    url: '/service/xld/bell_servicecont_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_servicecontview',
      id
    },
  })
}

// 1023 派单管理-验证
export function verifyDispatch(data) {
  return request({
    url: '/service/xld/park_catering_service_order_get_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'park_catering_service_order_getcheck',
      ...data
    },
  })
}

// 934 服务类型管理-列表
export function getServiceTypeList(data) {
  return request({
    url: '/service/xld/bell_servicetype_Hand.ashx', // 接口地址需根据实际情况调整
    method: "get",  // 接口方法
    params: {
      Method: 'bell_servicetypepage',
      pageindex: 1,
      pagesize: 5,
     ...data
    },
  })
}
